import LayoutSubmaster from "../../components/layoutSubmasterConfig/layoutSubmaster";
import { useEffect, useState } from "react";
import Layout from "../../components/layoutMasterConfig/layoutMaster";
import { setupAPIclient } from "../../services/setupAPIclientAuth";
import { toast } from "react-toastify";
import { Zip_Code_Api } from "../../services/zip_code_api/zip_code_api";
import DataTable, { TableColumn } from "react-data-table-component";
import { apiClientMater } from "../../services/setupClientMaster/apiClientMaster";
import LocalStorage from "../../helpers/localstorage";
import { apiClientSubmaster } from "../../services/setupClientSubmaster/apiClientSubmaster";

function ConfigSubmasterClient(){

    const marginFilter = { marginLeft: "-0.3%"};

    const getAuthToken = () => {
        const localStorage = new LocalStorage()
        return localStorage.getAuthToken();
    }
    const token = String(getAuthToken());

    const getStorage = () => {
        const localStorage = new LocalStorage()
        return localStorage;
    }

    type DataRowAnimal = {
        id: number;
        name: string;
        breed: string;
        speciesofdog:string;
        pet_size:string;
        sex:string
    };


  type DataRow = {
    id: number;
    name: string;
    email: string;
    number: string;
    address: string; 
    city: string; 
    pet_quantity: number; 
    postal_code: string; 
    state: string; 
    neighborhood:string;
    house_number: string;
    animalsubmasterId: []
  };
  

    const [showAnimalFormUpdate ,setShowFormUpdateAnimal ] = useState(false);

    const [showAnimalFormCreate ,setShowFormCreate] = useState(false);



    const [showModalAnimal , setShowModalAnimal ] = useState(false);
    const [getData, setgetData] = useState<DataRow[]>([]);

    const [getDataAnimal, setgetDataAnimal] = useState<DataRowAnimal[]>([]);


    const [formData, setFormData] = useState<{
        id: number;
        name: string;
        email: string;
        address: string;
        neighborhood: string;
        postal_code: string;
        city: string;
        state: string;
        number: string;
        house_number:  string,
        animalsubmasterId:  string[];
      }>({
        id: 0,
        name: "",
        email: "",
        number:  "",
        address:  "",
        city:  "",
        postal_code:  "",
        state:  "",
        neighborhood: "",
        house_number:  "",
        animalsubmasterId:  []
      }); 
    const [formDataAnimal , setFormDataAnimal] = useState<{    
        name: string;
        breed:string;
        speciesofdog:string;
        pet_size:string;
        sex:string
     }>({
        name: "",
        breed: "",
        speciesofdog:"",
        pet_size:"",
        sex:""

    });
    const handleChange = (e: { target: { name: any; value: any; type: any; checked: any; }; }) => {
        const { name, value, type, checked } = e.target;
        setFormData({
          ...formData,
          [name]: value,
        });
      };

  
    const resetFormAnimal  = (enableModalAnimal:boolean) => {
        setFormDataAnimal({
            name: '',
            breed:"",
            speciesofdog:"",
            pet_size:"",
            sex:""
        });
        if(enableModalAnimal){
         setShowModalAnimal(true)
        }
    };

    async function handleChangePostalcode(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>){
        setFormData({
          ...formData,                
          postal_code: e.target.value, 
        });
        const apiclient =  Zip_Code_Api(e.target.value)
        const response =  await apiclient.get("")
        if(response && response.data ){
          setFormData({
            ...formData,
            neighborhood: response.data.bairro,
            state: response.data.estado,
            city: response.data.localidade,
            address: response.data.logradouro
          });
        } 
      }


      function maskPhone(e: React.ChangeEvent<HTMLInputElement>){
        let phone = e.target.value;
        phone = phone.replace(/\D/g, ''); // Remove tudo o que não é número
        phone = phone.replace(/(\d{2})(\d)/, '($1) $2');
        phone = phone.replace(/(\d{5})(\d{1,4})$/, '$1-$2');
          setFormData({ ...formData, number: phone });
      };

    const handleSubmitUpdate = async () => {
        if(!formData.email){
            return toast.warning("O e-mail não pode estar vazio")
          }else if(!formData.number){
            return toast.warning("O número de celular não pode estar vazio")
          } else {
            try {
                const ApiClient =  apiClientSubmaster(token);
                const response = await ApiClient.post(`/crud/update/ClientSubmaster/${Iduser}`, {
                    id: formData.id,
                    name: formData.name,
                    email: formData.email,
                    number: formData.number,
                    address: formData.address, 
                    city: formData.city,
                    postal_code: formData.postal_code,
                    state: formData.state, 
                    neighborhood:formData.neighborhood,
                    house_number: formData.house_number,
                    animalsubmasterId: formData.animalsubmasterId,
                    submasterId: String(getStorage().getId())
                });
                if (response.status >= 200 && response.status < 300) {
                    toast.success("Cliente atualizado com sucesso!");
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                    } else {
                    throw new Error(`Erro inesperado: ${response.status}`);
                }
            }catch(e){
                toast.dismiss(loadingToast());
                toast.error("Este e-mail já está cadastrado! É necessário preencher outro e-mail. Tente novamente.");
            }
        }
    }


     const loadingToast = () => {
        return toast.info("Processando... aguarde", {
            autoClose: false, 
        });
     };

    const handleSubmitCreate = async () => {
        /**/ 
        if(!formData.email){
            return toast.warning("O e-mail não pode estar vazio")
          }else if(!formData.number){
            return toast.warning("O número de celular não pode estar vazio")
          } else {
            try {
                const ApiClient =  apiClientSubmaster(token);
                const response = await ApiClient.post("/crud/create/ClientSubmaster", {
                    name: formData.name,
                    email: formData.email,
                    number: formData.number,
                    address: formData.address, 
                    city: formData.city,
                    postal_code: formData.postal_code,
                    state: formData.state, 
                    neighborhood:formData.neighborhood,
                    house_number: formData.house_number,
                    animalsubmasterId: formData.animalsubmasterId,
                    submasterId: Number(getStorage().getId()),
                    number_active:false,
                    access_permission_request: false
                });
                if (response.status >= 200 && response.status < 300) {
                    toast.success("Cliente cadastrado com sucesso!");
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                    } else {
                    throw new Error(`Erro inesperado: ${response.status}`);
                }
            }catch(e){
                toast.dismiss(loadingToast());
                toast.error("Este e-mail já está cadastrado! É necessário preencher outro e-mail. Tente novamente.");
            }
        }
    }


    const [animalselected, setAnimalselected] = useState<{ id: number; name: string }[]>([]);

    const handlegetActivisionDataAnimal = async () => {
        const ApiClient =  apiClientSubmaster(token);
        const response = await ApiClient.post("/crud/getdata/AnimalSubmaster/"+ String(getStorage().getId()) + "/false");
         console.log("response" + response.data)
         const formattedAnimal = response.data.map((item: any) => ({
             id: item.id,
             name: item.name ?? "",
             breed: item.breed,
             speciesofdog:item.speciesofdog,
             pet_size: item.pet_size,
             sex:item.sex 

         }));
         setAnimalselected(response.data.map((item: any) => ({
             id: item.id, 
             name: Array.isArray(item.name) 
             ? item.name.join(", ") 
             : item.name ?? "Sem animal", 
         })))
         console.log("dado animal"+ formDataAnimal)
     }

     const columns: TableColumn<DataRow>[] = [
        {
          name: "Nome",
          selector: (row) => row.name,
          sortable: true,
        },
        {
          name: "E-mail",
          selector: (row) => row.email,
          sortable: true,
        },
        {
          name: "Telefone",
          selector: (row) => row.number,
          sortable: true,
        },
        {
          name: 'Ações',
          cell: (row: { id: number }) => (
            <button className='btn-sm btn btn-success'  onClick={() => handleButtonUpdate(row.id)}>Editar</button>
          ),
          ignoreRowClick: true, 
          allowOverflow: true,
          button: true
        },
      ];

      const [Iduser, setShowIduser] = useState(0);
      const [showFormUpdate, setShowFormUpdate] = useState(false);

      
      const handleButtonUpdate = (id: number) => {

        const selectedItem = getData.find((item) => item.id === id);
    
        console.log(`Item com ID ${id} foi clicado! ${formData?.city}`);
    
    
        setShowIduser(id)
    
        setFormData({
            id: selectedItem?.id ?? 0,
            name: selectedItem?.name ?? '',
            email: selectedItem?.email ?? '',
            number: selectedItem?.number ?? "",
            address: selectedItem?.address ?? '',
            city: selectedItem?.city ?? '',
            postal_code: selectedItem?.postal_code ?? '',
            state: selectedItem?.state ?? '',
            neighborhood:selectedItem?.neighborhood?? '',
            house_number: selectedItem?.house_number?? '',
            animalsubmasterId: selectedItem?.animalsubmasterId?? [],
        });
        setShowFormUpdateAnimal(true)
        handlegetActivisionDataAnimal()
      }
      const [filterText, setFilterText] = useState(""); 
      const filteredData = getData.filter(
        (item) =>
          item.email?.toLowerCase().includes(filterText.toLowerCase()) 
      );

      const handleClearData = () => {
        // Resetando o formData para garantir que esteja vazio
        setFormData({
            id: 0,
            name: "",
            email:"",
            number:"",
            address: "",
            city: "",
            postal_code:"",
            state: "",
            neighborhood:"",
            house_number: "",
            animalsubmasterId: [],
        });
    
      }


    useEffect(() => {
       
        const handlegetActivisionDataClient = async () => {
            const ApiClient = apiClientSubmaster(token);
            const response = await ApiClient.post("/crud/getdata/EmployeesSubmaster/" + String(getStorage().getId())+ "/false") ;
            console.log(response.data)
            const formatdata = response.data.map((item: any) => ({
                id: item.id,
                name: item.name,
                email: item.email,
                number: item.number,
                address: item.address, 
                city: item.city,
                postal_code: item.postal_code,
                state: item.state, 
                neighborhood:item.neighborhood,
                house_nummber: item.house_number,
                animalsubmasterId: item.animalsubmasterId
            }));
            setFormData(formatdata)
            setgetData(formatdata)

        }
        handlegetActivisionDataClient()
    }, []);

    return (
        <LayoutSubmaster>
            <div className="row">
                {!showAnimalFormUpdate ? (
                    <div>
                    <div className="mt-3">
                        <button className='btn btn-success'onClick={() => {
                            setShowFormCreate(true);
                            handleClearData()

                            handlegetActivisionDataAnimal();

                        }}>
                            Cadastrar cliente
                        </button>
                    </div>
                    <div className="row mb-3 mt-3">
                            <div >
                                <h5>Tabela de clientes </h5>
                            </div>
                                <div style={marginFilter}>
                                    <input
                                        type="text"
                                        placeholder="Filtrar por cliente"
                                        onChange={(e) => setFilterText(e.target.value)}
                                        style={{
                                            marginBottom: "10px",
                                            padding: "8px",
                                            width: "30%",
                                            border: "1px solid #ccc",
                                            borderRadius: "5px",
                                        }}/>
                                </div>
                                <DataTable  
                                columns={columns}
                                data={filteredData}
                                pagination
                                onSelectedRowsChange={(selected) =>
                                    console.log("Selected Rows: ", selected.selectedRows)
                                }
                                paginationComponentOptions={{
                                    rowsPerPageText: 'Página', 
                                    rangeSeparatorText: 'of',
                                    selectAllRowsItem: true, 
                                    selectAllRowsItemText: 'Select All'
                                }}
                                />
                        </div>  
                    </div>
                    ) :
                    <div  className="col-md-12 d-flex align-items-center justify-content-center">
                        <div className='card mt-3 col-md-7'>
                            <div className="modal-body">
                                    <div className="mb-4 ml-2"> 
                                        <h5 className="modal-title">Editar cliente </h5>
                                    </div>

                                    <form  method="POST">
                                            <div className="row">
                                            {/* Name */}
                                            <div className="col-md-6 mb-3">
                                            <input
                                                type="text"
                                                id="name"
                                                name="name"
                                                className="form-control"
                                                placeholder="Nome"
                                                value={formData.name}
                                                onChange={handleChange}
                                                required
                                            />
                                            </div>

                                            {/* Email */}
                                            <div className="col-md-6 mb-3">
                                            <input
                                                type="text"
                                                id="email"
                                                name="email"
                                                className="form-control"
                                                placeholder="E-mail"
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                                disabled
                                            />
                                            </div>
                                            </div>
                                            <div className="row">
                                                {/* Address */}
                                                <div className="col-md-6 mb-3">
                                                <input
                                                    type="text"
                                                    id="address"
                                                    name="address"
                                                    className="form-control"
                                                    placeholder="Endereço"
                                                    value={formData.address}
                                                    onChange={handleChange}
                                                    required
                                                />
                                                </div>

                                                {/* Neighborhood */}
                                                <div className="col-md-6 mb-3">
                                                <input
                                                    type="text"
                                                    id="neighborhood"
                                                    name="neighborhood"
                                                    className="form-control"
                                                    placeholder="Bairro"
                                                    value={formData.neighborhood}
                                                    onChange={handleChange}
                                                    required
                                                />
                                                </div>
                                            </div>
                                            <div className="row">
                                                {/* Postal Code */}
                                                <div className="col-md-6 mb-3">
                                                <input
                                                    type="text"
                                                    id="postal_code"
                                                    name="postal_code"
                                                    className="form-control"
                                                    placeholder="CEP"
                                                    value={formData.postal_code}
                                                    onChange={handleChangePostalcode}
                                                    required
                                                />
                                                </div>

                                                {/* City */}
                                                <div className="col-md-6 mb-3">
                                                <input
                                                    type="text"
                                                    id="city"
                                                    name="city"
                                                    className="form-control"
                                                    placeholder="Cidade"
                                                    value={formData.city}
                                                    onChange={handleChange}
                                                    required
                                                />
                                                </div>
                                            </div>
                                            <div className="row">
                                                {/* State */}
                                                <div className="col-md-6 mb-3">
                                                <input
                                                    type="text"
                                                    id="state"
                                                    name="state"
                                                    className="form-control"
                                                    placeholder="Estado"
                                                    value={formData.state}
                                                    onChange={handleChange}
                                                    required
                                                />
                                                </div>

                                                 {/* Transport Type - Select */}

                                                 <div className="col-md-6 mb-3">
                                                <input
                                                    type="text"
                                                    className="fadeIn second form-control"
                                                    name="number"
                                                    id="number"
                                                    placeholder="Número de Telefone"
                                                    value={formData.number}
                                                    onChange={maskPhone}
                                                    required
                                                />
                                                </div>

                                            </div>
                                            <div className="form-group col-md-12 d-flex flex-column align-items-center">
                                            <select
                                                className="fadeIn second form-control"
                                                name="animalsubmasterId"
                                                id="animalsubmasterId"
                                                required
                                                value={formData.animalsubmasterId}
                                                onChange={handleChangeAnimal}
                                                multiple
                                                >
                                                {animalselected.map((value) => (
                                                    <option key={value.id} value={value.id}>
                                                    {value.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </form>
                                <div className="modal-footer">
                                    <button className="btn btn-secondary" onClick={() => setShowFormUpdateAnimal(false)}>Fechar</button>
                                    <button className="btn btn-success" onClick={handleSubmitUpdate}>Editar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                </div>






                {/* Modal do Bootstrap animal */}
                 {(showAnimalFormCreate) && (
                    <div className="modal fade show d-block">
                        <div className="modal-dialog modal-xl">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Cadastro de cliente </h5>
                                    <button type="button" className="btn-close" onClick={() => setShowFormCreate(false)} ></button>
                                </div>
                                <div className="modal-body">
                                <form  method="POST">
                                        <div className="row">
                                        {/* Name */}
                                        <div className="col-md-6 mb-3">
                                        <input
                                            type="text"
                                            id="name"
                                            name="name"
                                            className="form-control"
                                            placeholder="Nome"
                                            onChange={handleChange}
                                            required
                                        />
                                        </div>

                                        {/* Email */}
                                        <div className="col-md-6 mb-3">
                                        <input
                                            type="text"
                                            id="email"
                                            name="email"
                                            className="form-control"
                                            placeholder="E-mail"
                                            onChange={handleChange}
                                            required
                                            
                                        />
                                        </div>
                                        </div>
                                        <div className="row">
                                            {/* Address */}
                                            <div className="col-md-6 mb-3">
                                            <input
                                                type="text"
                                                id="address"
                                                name="address"
                                                className="form-control"
                                                placeholder="Endereço"
                                                onChange={handleChange}
                                                required
                                                value={formData.address}

                                            />
                                            </div>

                                            {/* Neighborhood */}
                                            <div className="col-md-6 mb-3">
                                            <input
                                                type="text"
                                                id="neighborhood"
                                                name="neighborhood"
                                                className="form-control"
                                                placeholder="Bairro"
                                                onChange={handleChange}
                                                value={formData.neighborhood}
                                                required
                                            />
                                            </div>
                                        </div>
                                        <div className="row">
                                            {/* Postal Code */}
                                            <div className="col-md-6 mb-3">
                                            <input
                                                type="text"
                                                id="postal_code"
                                                name="postal_code"
                                                className="form-control"
                                                placeholder="CEP"
                                                value={formData.postal_code}
                                                onChange={handleChangePostalcode}
                                                required
                                            />
                                            </div>

                                            {/* City */}
                                            <div className="col-md-6 mb-3">
                                            <input
                                                type="text"
                                                id="city"
                                                name="city"
                                                className="form-control"
                                                placeholder="Cidade"
                                                value={formData.city}
                                                onChange={handleChange}
                                                required
                                            />
                                            </div>
                                        </div>
                                        <div className="row">
                                            {/* State */}
                                            <div className="col-md-6 mb-3">
                                            <input
                                                type="text"
                                                id="state"
                                                name="state"
                                                className="form-control"
                                                placeholder="Estado"
                                                value={formData.state}

                                                onChange={handleChange}
                                                required
                                            />
                                            </div>

                                            {/* House number */}

                                            <div className="col-md-6 mb-3">
                                            <input
                                                type="text"
                                                id="house_number"
                                                name="house_number"
                                                className="form-control"
                                                placeholder="Número da casa ou apartamento"
                                                onChange={handleChange}
                                                required
                                            />
                                            </div>

                                        </div>
                                        <div className="row">

                                            <div className="col-md-6 mb-3">
                                            <input
                                                type="text"
                                                className="fadeIn second form-control"
                                                name="number"
                                                id="number"
                                                placeholder="Número de Telefone"
                                                onChange={maskPhone}
                                                required
                                            />
                                            </div>
                                        </div>
                                        <div className="form-group col-md-12 d-flex flex-column align-items-center">
                                            <select
                                                className="fadeIn second form-control"
                                                name="animalsubmasterId"
                                                id="animalsubmasterId"
                                                required
                                                value={formData.animalsubmasterId}
                                                onChange={handleChangeAnimal}
                                                multiple
                                                >
                                                {animalselected.map((value) => (
                                                    <option key={value.id} value={value.id}>
                                                    {value.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </form>
                                </div>
                                <div className="modal-footer">
                                    <button className="btn btn-secondary" onClick={() => setShowFormCreate(false)}>Fechar</button>
                                    <button className="btn btn-success"  onClick={handleSubmitCreate} >Salvar</button>

                                </div>
                            </div>
                        </div>
                    </div>
                )}
            
                {/* Background escuro (overlay) */}
                {(showAnimalFormCreate) && <div className="modal-backdrop fade show"></div>}
               



        </LayoutSubmaster>
    )

    function handleChangeAnimal(event: React.ChangeEvent<HTMLSelectElement>) {
    
        const selectedOptions = Array.from(event.target.selectedOptions, (option) => option.value); 


        console.log("dadoi" + selectedOptions)
        setFormData((prevData) => ({
          ...prevData,
          animalsubmasterId: selectedOptions,
        }));
      }
    
}

export default ConfigSubmasterClient;